/**
 * Why an order stopped, as `orders.failure_code` records it.
 *
 * ONE LIST, for the code that writes a reason and the screen that reads one.
 * The reasons were string literals in three files, one of them an exported
 * constant and two of them inside SQL, and the admin printed whatever it found:
 * an operator read `payment_window_closed` and had to know what it meant.
 *
 * `FAILURE_LABEL` is typed on the list, so a reason added here and not
 * labelled is a compile error rather than a raw code on the operator's screen.
 */
export const FAILURE = {
    /** The customer pressed Cancel on the payment screen. */
    CANCELLED: "cancelled",
    /** An operator closed the order from the admin. */
    CLOSED_BY_ADMIN: "closed_by_admin",
    /** No money arrived before the payment window closed. */
    PAYMENT_WINDOW_CLOSED: "payment_window_closed",
    /** Paid; the supplier purchase failed and is scheduled again. */
    PROVISION_RETRY: "provision_retry",
    /** Paid; the supplier purchase failed every scheduled attempt. */
    PROVISION_EXHAUSTED: "provision_exhausted",
    /** Paid; the supplier call's outcome is unknown and a person must check. */
    PURCHASE_OUTCOME_UNKNOWN: "purchase_outcome_unknown",
};
export const FAILURE_LABEL = {
    cancelled: "Cancelled by the customer",
    closed_by_admin: "Closed by an operator",
    payment_window_closed: "No payment before the window closed",
    provision_retry: "Supplier purchase failed; retry scheduled",
    provision_exhausted: "Supplier purchase failed every attempt",
    purchase_outcome_unknown: "Supplier purchase outcome unknown; check the supplier",
};
/** A reason in words, or the stored code itself when it is not one of ours. */
export function failureLabel(code) {
    if (code === null)
        return null;
    return FAILURE_LABEL[code] ?? code;
}
//# sourceMappingURL=failure-codes.js.map